import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'

import { paramsStore } from '#/app/store/model-parametres-store'
import { balanceSlice } from '#/entities/balance'
import { userSlice } from '#/entities/user-account'
import { chatsReducer } from '#/features/chats/chats-slice'
import modalsReducer from '#/features/modals/model/modals-slice'
import { pendingSlice } from '#/features/pending'
import { stepperSlice } from '#/features/register-business'
import { notificationSlice } from './notification-slice'
import toastReducer from './toast-slice'

export const store = configureStore({
	reducer: {
		balance: balanceSlice.reducer,
		stepper: stepperSlice.reducer,
		user: userSlice.reducer,
		notification: notificationSlice.reducer,
		toast: toastReducer,
		modals: modalsReducer,
		params: paramsStore.reducer,
		loading: pendingSlice.reducer,
		chats: chatsReducer,
	},
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export type loadingThunk = 'idle' | 'pending' | 'succeeded' | 'failed'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
